import { Navigate, Outlet } from 'react-router-dom';

import { getAccessToken } from '@/api/token';
import { PUBLIC_ROUTE } from '@/router/constant/routes';

export function ProtectedRoute() {
    const token = getAccessToken();

    if (!token) {
        return <Navigate to={PUBLIC_ROUTE.LOGIN} replace />;
    }

    return <Outlet />;
}
